import { FunctionComponent, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import {
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { NavLink } from 'react-router-dom';

export const StyledNavLink = styled(NavLink)`
  text-decoration: none;
`;
export const StyledNavItem = styled(ListItemButton)(({ theme }) => ({
  ...theme.typography.body2,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  height: 48,
  position: 'relative',
  textDecoration: 'none',
  textTransform: 'capitalize',
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  height: 22,
  justifyContent: 'center',
  width: 22,
});

export type NavItemProps = {
  icon?: ReactNode;
  info?: ReactNode;
  path: string;
  title: ReactNode;
} & ListItemButtonProps;

export const NavItem: FunctionComponent<NavItemProps> = (props) => {
  const { icon, info, path, title, ...navItemProps } = props;
  return (
    <StyledNavLink to={path}>
      <StyledNavItem disableGutters {...navItemProps}>
        {icon && <StyledNavItemIcon>{icon}</StyledNavItemIcon>}
        <ListItemText disableTypography primary={title} />
        {info && info}
      </StyledNavItem>
    </StyledNavLink>
  );
};
